<template>
    <section class="project" :class="$mq">
        <base-window v-if="video" class="project-video">
            <iframe
                :class="$mq"
                :src="video"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            />
            <div v-if="awards" class="award" :class="$mq">
                <img
                    v-for="(award, index) in awards"
                    :key="index"
                    :src="award"
                    alt="award"
                />
            </div>
        </base-window>

        <div v-if="awards" class="award-mobile" :class="$mq">
            <img
                v-for="(award, index) in awards"
                :key="index"
                :src="award"
                alt="award"
            />
        </div>

        <div class="content" :class="{ 'no-video': !video }">
            <base-text type="h4" class="name">{{ name }}</base-text>
            <base-text
                type="p"
                class="description"
                v-html="makeHtml(description)"
            />

            <div class="developers">
                <div
                    v-for="(developer, index) in developers"
                    :key="index"
                    class="developer"
                >
                    <base-text type="h5" class="developer-name">
                        {{ developer.name }}
                    </base-text>
                    <a
                        v-for="(weblink, index) in developer.weblinks"
                        :key="index"
                        :href="isEmail(weblink) ? `mailto:${weblink}` : weblink"
                        :target="isEmail(weblink) ? '' : '_blank'"
                        :rel="isEmail(weblink) ? '' : 'noopener'"
                        class="weblink"
                    >
                        <base-text type="h6">{{ weblink }}</base-text>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import showdown from 'showdown';

    export default {
        name: 'project',

        props: {
            name: {
                type: String,
                required: true,
            },

            developers: {
                type: Array,
                required: true,
            },

            description: {
                type: String,
                required: true,
            },

            video: {
                type: String,
                required: false,
                default() {
                    return null;
                },
            },

            awards: {
                type: Array,
                required: false,
                default() {
                    return null;
                },
            },
        },

        methods: {
            makeHtml(content) {
                const converter = new showdown.Converter();
                return converter.makeHtml(content);
            },

            isEmail(link) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(link).toLowerCase());
            },
        },
    };
</script>

<style lang="scss" scoped>
    .project {
        display: flex;
        align-items: center;
        justify-content: center;

        .project-video {
            width: 60%;
            position: relative;

            iframe {
                width: 100%;
                height: 400px;

                &.mobile {
                    height: 250px;
                }
            }

            .award {
                position: absolute;
                right: -15px;
                top: -80px;

                img {
                    width: 110px;

                    &:not(:last-of-type) {
                        margin-right: 10px;
                    }
                }

                &.mobile {
                    display: none;
                }
            }
        }

        .award-mobile {
            display: none;
            margin-bottom: 20px;
            flex-wrap: wrap;
            justify-content: center;

            img {
                width: 110px;
                margin: 0 10px 10px;
            }

            &.mobile {
                display: flex;
            }
        }

        .content {
            width: 40%;
            margin-left: 50px;

            .name {
                margin-bottom: 5px;
            }

            .description {
                margin-bottom: 30px;

                /deep/ a {
                    color: white;
                }
            }

            .developers {
                display: flex;
                flex-wrap: wrap;
            }

            .developer {
                &:not(:last-of-type) {
                    margin-right: 15px;
                    margin-bottom: 15px;
                }

                .developer-name {
                    margin-bottom: 2px;
                }

                .weblink {
                    display: block;
                    color: white;

                    &:not(:last-of-type) {
                        margin-bottom: 2px;
                    }
                }
            }

            &.no-video {
                width: 100%;
                margin-left: 0;
            }
        }

        &.tablet,
        &.mobile {
            flex-direction: column;

            .project-video {
                width: 100%;
            }

            .content {
                width: 100%;
                margin-left: 0;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }

        &.tablet {
            .project-video {
                margin-bottom: $standard-space;
            }
        }

        &.mobile {
            .project-video {
                margin-bottom: $standard-space-mobile;
            }
        }
    }
</style>
